<template>
    <div class="MyMap" id="map" :style="'height:'+height+'px'">

    </div>
</template>
  
<script>
import mapboxgl from 'mapbox-gl';
export default {
    name: 'MyMap',
    props: {
        coordinate: {
            type: Object,
            default: null,
        },
        height:{
            type:Number,
            defalut:300
        }
    },

    data: function () {
        return {
            MyMap: "",
            // queryCoordinate: {
            //     start: [-117.59998, 34.13762],
            //     end: [-118.262848, 33.743559]
            // },
            startNo: [],
            endNo: [],
            aheight:300
        }
    },
    methods: {
        getLine(val) {
        },
        createMap() {
            mapboxgl.accessToken =
                'pk.eyJ1Ijoib3Jpbm9oYW4iLCJhIjoiY2xlaWJjZHFiMDFmeDQzbWliM3p2NjQ4eSJ9.7iPD5KsH3Ti5Tc2tNmpP3Q';
            this.MyMap = new mapboxgl.Map({
                container: 'map',
                // style: 'mapbox://styles/mapbox/streets-v12',
                style: 'mapbox://styles/mapbox/streets-v10',
                center: [-97.27818763083295, 39.301229442069456],
                zoom: 1.8
            });
            this.MyMap.setMaxBounds([-150, -52, -40, 83])
        },
        clearPoint() {
            if (this.MyMap.getLayer('end')) {
                this.MyMap.removeLayer('end');
            }
            if (this.MyMap.getSource('end')) {
                this.MyMap.removeSource('end');
            }
            if (this.MyMap.getLayer('start')) {
                this.MyMap.removeLayer('start');
            }
            if (this.MyMap.getSource('start')) {
                this.MyMap.removeSource('start');
            }
            if (this.MyMap.getLayer('route')) {
                this.MyMap.removeLayer('route');
            }
            if (this.MyMap.getSource('route')) {
                this.MyMap.removeSource('route');
            }
        },
        clearLine() {
            this.clearPoint()
            this.distance = 0
            this.MyMap.zoomTo(3, {
                duration: 2000,
            });
            this.MyMap.fitBounds([
                [-127.28009908690083, 36.57085089519492],
                [-75.41864229471571, 34.029870508444915]
            ])
        },
        autZoom() {
            this.MyMap.fitBounds(
                [[this.startNo[0], this.startNo[1]],
                [this.endNo[0], this.endNo[1]]],
                {
                    padding: 40
                }
            )
        },
        getAddressMsg(start, end) {
            this.startNo = start
            this.endNo = end
            this.clearPoint()
            setTimeout(() => {
                this.MyMap.addLayer({
                    id: 'end',
                    type: 'circle',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: [{
                                type: 'Feature',
                                properties: {
                                    title: "终点"
                                },
                                geometry: {
                                    type: 'Point',
                                    coordinates: this.startNo
                                }
                            }]
                        }
                    },
                    paint: {
                        'circle-radius': 10,
                        'circle-color': '#3887be'
                    }
                });
                this.MyMap.addLayer({
                    id: 'start',
                    type: 'circle',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: [{
                                type: 'Feature',
                                properties: {},
                                geometry: {
                                    type: 'Point',
                                    coordinates: this.endNo
                                }
                            }]
                        }
                    },
                    paint: {
                        'circle-radius': 10,
                        'circle-color': '#ff0000'
                    }
                });
                this.getRoute(this.startNo,
                    this.endNo)
            }, 500)
        },
        async getRoute(start, end) {

            const query = await fetch(
                `https://api.mapbox.com/directions/v5/mapbox/driving/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`, {
                method: 'GET'
            }
            );
            this.resJson = await query.json();
            if (this.resJson.routes && this.resJson.routes.length > 0) {
                const data = this.resJson.routes[0];
                const route = data.geometry.coordinates;
                const geojson = {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'LineString',
                        coordinates: route
                    }
                };
                // if the route already exists on the map, we'll reset it using setData
                if (this.MyMap.getSource('route')) {
                    this.MyMap.getSource('route').setData(geojson);
                }
                // otherwise, we'll make a new request
                else {
                    this.MyMap.addLayer({
                        id: 'route',
                        type: 'line',
                        source: {
                            type: 'geojson',
                            data: geojson
                        },
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        paint: {
                            'line-color': '#3887be',
                            'line-width': 5,
                            'line-opacity': 0.75
                        }
                    });
                }
                // this.distance = this.resJson.routes[0].distance / 1000
                this.$emit("getDistance", this.resJson.routes[0].distance / 1000);
                this.autZoom()
            }
            else {
                this.$message({
                    // message: this.resJson.message,
                    message: "未能匹配路线",
                    type: 'error'
                });
            }
        },
    },
    mounted() {
        this.createMap()
    },
    // watch: {
    //     height: {
    //         handler(newVal, oldVal) {
    //             this.height = newVal
    //         },
    //         deep: true,
    //     },
    // },
}
</script>
<style scoped>
.MyMap {
    
}

</style>
 